import { Create, CreateProps, SimpleForm } from 'react-admin';

import { useCreateProps, useRbacCreate } from '@hooks';
import { Forbidden, InitialPage } from '@components';
import { ManualsForm, validate } from '@pages/support/manuals/ManualsForm';
import cls from './Manuals.module.css';

export const ManualsCreate = (props: CreateProps) => {
  const createProps = useCreateProps();
  const rbacCreate = useRbacCreate();

  if (!rbacCreate) {
    return <Forbidden />;
  }

  return (
    <Create {...props} {...createProps} title="Create Tech Tool Manual" className={cls.page}>
      <InitialPage
        title="Creation of Verqor Tech Tool Manual"
        backTo="/manuals"
        backText="Back to all manuals"
      >
        <SimpleForm validate={validate}>
          <ManualsForm />
        </SimpleForm>
      </InitialPage>
    </Create>
  );
};
